import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Summa

  <span style="color:#85c1dc;">**FI:**</span>
  Summa

  <span style="color:#85c1dc;">**RU:**</span>
  Сумма
*/
/* @__NO_SIDE_EFFECTS__ */
const m111 = msg(
  mf`Summa`,
  mf`Summa`,
  mf`Сумма`,
)

export { m111 as 'w.module.product_hero.sum' }